import { Component, OnInit, AfterViewInit } from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import { ExportExcelService } from 'app/service/export-excel.service'
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-profit-data',
  templateUrl: './profit-data.component.html',
  styleUrls: ['./profit-data.component.scss']
})
export class ProfitDataComponent implements OnInit, AfterViewInit {
  chart
  pdfChart: PdfChart = new PdfChart()
  profitDataTableOptions: DataTables.Settings = {}
  dataChart
  lastTradingDate
  getPrint
  header = []
  asOfDate
  listExchangeMacro
  listProfitData = []
  listHeader = []
  dataProvider
  ws_data
  listYear = []

  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print;
    this.pdfChart.setPdf(pdf)

    this.profitDataTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      language: {
        emptyTable: 'No information found'
      },
    }
    this.makeChart().then(() => {
    })
  }

  async makeChart() {

    await this.cpmService
      .getExchangeNetProfit()
      .then(obj => {
        let listData = [];
        this.asOfDate = this.datePipe.transform(obj.asOfDate, 'd MMM yyyy')
        listData = obj.netProfit
        return this.makeData(listData)
      })

    this.dataChart = {
      type: 'serial',
      categoryField: 'category',
      theme: 'none',
      fontFamily: 'browallia',
      fontSize: 18,
      categoryAxis: {
        gridPosition: 'start'
      },
      graphs: [
        {
          fillAlphas: 1,
          id: 'AmGraph-1',
          title: this.listYear[0],
          type: 'column',
          valueField: 'year1',
          lineColor: '#5f6062',
          fillColors: '#5f6062',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          fillAlphas: 1,
          id: 'AmGraph-2',
          title: this.listYear[1],
          type: 'column',
          valueField: 'year2',
          lineColor: '#D6D6DA',
          fillColors: '#D6D6DA',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          id: 'AmGraph-3',
          fillAlphas: 1,
          title: this.listYear[2],
          type: 'column',
          valueField: 'year3',
          lineColor: '#ffd200',
          fillColors: '#ffd200',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          id: 'AmGraph-4',
          fillAlphas: 1,
          title: this.listYear[3],
          type: 'column',
          valueField: 'year4',
          lineColor: '#fbb034',
          fillColors: '#fbb034',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        },
        {
          id: 'AmGraph-5',
          fillAlphas: 1,
          title: 'YTD',
          type: 'column',
          valueField: 'year5',
          lineColor: '#f98500',
          fillColors: '#f98500',
          labelText: '[[value]]',
          labelPosition: 'top',
          labelRotation: 270
        }
      ],
      valueAxes: [
        {
          id: 'ValueAxis-1',
          gridThickness: 0,
          title: 'Net profit (M. USD)'
        }
      ],
      legend: {
        enabled: true,
        position: 'bottom',
        useGraphSettings: true,
        align: 'center'
      },
      titles: [
        {
          id: 'Title-1',
          size: 20,
          text: 'Net profit in ASEAN exchanges in 5 years'
        }
      ],
      dataProvider: this.dataProvider
    }


    this.chart = this.amCharts.makeChart('chartdiv', this.dataChart)
  }

  async makeData(listData) {

    await this.cpmService.getExchangeMacro().then(obj => {
      this.listExchangeMacro = obj.macroData.map(data => {
        return data
      })
    })

    this.listProfitData = [];
    this.dataProvider = [];

    listData.map(obj => {
      const marcro = this.listExchangeMacro.find(
        marcroObj => marcroObj.market === obj.market
      )

      const profic = {}
      profic['market'] = obj.country.concat(' ').concat(obj.market)
      profic['country'] = obj.country
      profic['pts'] = marcro.indexLastPrice
      profic['pe'] = marcro.pe
      profic['indexChange'] = marcro.indexChange
      profic['total'] = obj.netProfit
        .slice(0, 4)
        .map(x => x.netProfit)
        .reduce((a, b) => a + b, obj.profitYtd)
        .toFixed(0)

      this.listYear = []
      const listHeader = [
        'Exchanges',
        'Last price (pts)',
        'Last P/E (x)',
        'Index change YTD (%)'
      ]
      listData[0].netProfit
        .map(x => x.year)
        .slice(0, 4)
        .reverse()
        .forEach(element => {
          this.listYear.push(element)
        })
      this.listHeader = [...listHeader, ...this.listYear, 'YTD', 'Total']

      let i = 1
      this.listYear.forEach(year => {
        profic['year' + i] = obj.netProfit
          .find(element => element.year === year)
          .netProfit.toFixed(0)
        i = i + 1
      })

      profic['ytd'] = obj.profitYtd.toFixed(0)
      profic['pe'] = profic['pe']
      profic['pts'] = profic['pts']
      profic['indexChange'] = profic['indexChange']

      this.listProfitData.push(profic)

      const dataProvider = {
        category: profic['country'],
        year1: profic['year1'],
        year2: profic['year2'],
        year3: profic['year3'],
        year4: profic['year4'],
        year5: profic['ytd']
      }

      this.dataProvider.push(dataProvider)
    })
    listData = [];
  }

  dataToExcel() {
    this.excelService.exportExcelData(this.getWs_data(), 'Profit Data')
  }

  getWs_data() {
    this.ws_data = []
    this.ws_data.push([...this.listHeader])
    this.listProfitData.map(obj => {
      const list = [
        obj.market,
        obj.pts,
        obj.pe,
        obj.indexChange,
        this.numberToNoDecimal(obj.year1),
        this.numberToNoDecimal(obj.year2),
        this.numberToNoDecimal(obj.year3),
        this.numberToNoDecimal(obj.year4),
        this.numberToNoDecimal(obj.ytd),
        this.numberToNoDecimal(obj.total)
      ]
      this.ws_data.push([...list])
    })
    return this.ws_data
  }
  numberToNoDecimal(num) {
    return Number(parseFloat(num).toFixed(0))
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/profit-data/profit-data.component.ts